import { createContext, ReactNode, useState } from 'react';

interface PermissionsContext {
  permissions: string[];
  hasPermissionsLoaded: boolean;
  setPermissions: (permissions: string[]) => void;
  setHasPermissionsLoaded: (hasLoaded: boolean) => void;
  cleanupPermissions: () => void;
}

const initialState = {
  permissions: [],
  hasPermissionsLoaded: false,
  setPermissions: (_permissions: string[]) => {},
  setHasPermissionsLoaded: () => {},
  cleanupPermissions: () => {},
};

export const PermissionsContext = createContext<PermissionsContext>(initialState);

interface Props {
  children: ReactNode;
}

const PermissionsProvider = ({ children }: Props) => {
  const [permissions, setPermissions] = useState<string[]>(initialState.permissions);
  const [hasPermissionsLoaded, setHasPermissionsLoaded] = useState(false);

  const cleanupPermissions = () => setPermissions(initialState.permissions);

  return (
    <PermissionsContext.Provider
      value={{
        permissions,
        hasPermissionsLoaded,
        setPermissions,
        setHasPermissionsLoaded,
        cleanupPermissions,
      }}
    >
      {children}
    </PermissionsContext.Provider>
  );
};

export default PermissionsProvider;
